export default __webpack_public_path__ + "static/media/1b.d044461e.png";